import { TReactSetState } from "../../data/AppType";
import { CREATE_GALLERY_DIRECTORY_ITEM } from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  handleError,
  sweetAlertError,
  sweetAlertSuccess,
} from "../../utils/AppFunctions";

export interface IGalleryDirectoryItem {
  gallery_directory_id: string;
  gallery_media: {
    media_url: string;
  }[];
}

export const handleSubmitGalleryDirectoryItems = async (
  values: IGalleryDirectoryItem,
  setLoading: TReactSetState<boolean>,
  handleClose: (status: boolean) => void
) => {
  setLoading(true);
  try {
    const resultGalleryDirectory = await CREATE_GALLERY_DIRECTORY_ITEM(values);

    if (
      resultGalleryDirectory &&
      resultGalleryDirectory.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      sweetAlertSuccess({
        message: resultGalleryDirectory.message,
      });
      return handleClose(true);
    } else {
      sweetAlertError({
        message:
          resultGalleryDirectory?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (e: any) {
    handleError(e, "handleSubmitGalleryDirectoryItems");
  } finally {
    setLoading(false);
  }
};
